module.exports = __webpack_public_path__ + "static/media/brand-logo-alt.632722dc.png";